import {observer} from 'mobx-react-lite';
import React, {useCallback} from 'react';

import {StyledAction} from './styles';

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export type ActionProps = {
  /**
   * Label of the action rendered as the "children" of the "button"
   */
  label: string;
  /**
   * Will be called when the "onClick" event is triggered
   */
  callback: () => void;
  /**
   * Sets the "class" attribute of the underlying "HTMLElement"
   */
  className?: string;
};

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export function ActionComponent({
  callback,
  label,
  className,
}: ActionProps): React.ReactElement {
  const handleActionCallback = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      callback();
    },
    [callback]
  );

  const handleMouseDown = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
    },
    []
  );

  return (
    <StyledAction
      className={className}
      data-testid='input-action-button'
      type='button'
      onClick={handleActionCallback}
      onMouseDown={handleMouseDown}
    >
      {label}
    </StyledAction>
  );
}

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export default observer(ActionComponent);
